import React from "react";

export default function LiveMap({ loc, testid = "live-map", className = "w-full h-72" }) {
  if (!loc) return null;
  const src = `https://maps.google.com/maps?q=${loc.lat},${loc.lng}&z=15&output=embed`;
  return (
    <div data-testid={testid} className="rounded-2xl overflow-hidden border border-[#E5E0D8]">
      <iframe title="CHELA live location" src={src} className={className} loading="lazy" />
      <div className="px-3 py-2 text-xs text-[#5A5D65] bg-white">Updated {new Date(loc.at).toLocaleTimeString()}</div>
    </div>
  );
}
